import { RelativeTimeChip, VizContainer, VizContainerHeaderProps } from '@/components';

export interface VizPanelHeaderProps
  extends Pick<VizContainerHeaderProps, 'title' | 'description' | 'errors' | 'notices'> {
  showRelativeTimeChip?: boolean;
  showHeader?: boolean;
}

export const VizPanelHeader = ({
  title,
  description,
  showRelativeTimeChip,
  showHeader,
  ...props
}: VizPanelHeaderProps) => {
  if (showHeader) {
    return (
      <VizContainer.Header
        title={title}
        description={description}
        endAdornment={showRelativeTimeChip ? <RelativeTimeChip /> : undefined}
        {...props}
      />
    );
  }

  // If there is no title, actions float above panel on hover
  return <VizContainer.Actions />;
};
